import React from 'react';
import PipeMetricsDashboard from '../components/PipeMetricsDashboard';

const PipeMetricsPage: React.FC = () => {
  return <PipeMetricsDashboard />;
};

export default PipeMetricsPage;
